import { FC } from 'react';
import { HallmapContainer } from './styles';
import { HallmapProps } from '../lib/types';
import { useCanvasHallmap } from '../lib/hooks/useCanvasHallmap';

export const Hallmap: FC<HallmapProps> = ({
	setHallmap,
	id = 'hallmap',
	containerId = 'hallmap-container',
	mode = 'static',
	order,
}) => {
	useCanvasHallmap({
		setHallmap,
		id,
		containerId,
		mode,
		order,
	});

	return <HallmapContainer id={id} />;
};
